module.exports = "../img/weber-group-3T6NAlU.svg";